import { Component, h, Prop, Host, Fragment } from '@stencil/core';
import { CartItem, CartItemProduct, ConnectedArticle, Variation } from '../../../../redux/types';
import { t } from '../../../../redux/utils';
import { Price, RelativePrice, ShortPrice, TotalPriceCalculation } from '../../../../types/types';
import { getMileageAmountPerPeriod } from '../../../../utils/mileage';
import { itemKey } from '../../../../utils/trans';

@Component({
  tag: 'rtr-cart-reservation-content',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareCartControlButton {
  @Prop() cartItem!: CartItem;
  @Prop() connectedArticles!: ConnectedArticle[];
  @Prop() images!: string[];
  @Prop() onShowFullGallery!: (show: boolean) => void;
  @Prop() totalPriceCalculation: TotalPriceCalculation;

  get variationInCart(): Variation {
    return this.cartItem.products?.find(product => !!product.variation)?.variation;
  }

  get bundles(): CartItemProduct[] {
    return this.cartItem.products?.filter(product => !product.variation);
  }

  showTotalPriceForMileage = (relativePrice: RelativePrice, totalPrice: ShortPrice): boolean => {
    return totalPrice.gross !== relativePrice.price.gross && this.totalPriceCalculation === TotalPriceCalculation.Interval
  }

  showTotalPriceForCartItem = (relativePrice: Price, totalPrice: ShortPrice): boolean => {
    return totalPrice.gross !== relativePrice.gross && this.totalPriceCalculation === TotalPriceCalculation.Interval
  }

  renderMileage= () => {
    if (!this.cartItem.mileageOption?.id) {
      return null
    }

    const mileageOption = this.cartItem.mileageOption

    let mileageTotalAmount = ''
    if (mileageOption.relativeAmount.amount !== mileageOption.amount) {
      mileageTotalAmount = t('article.mileageOptionSelectOption', { amount: mileageOption.amount, unit: this.cartItem.mileageOption.config.unit })
    }

    return (
      <Fragment>
        <rentware-spacer size="S" />

        <div class="CRItemRow">
          <div>
            {getMileageAmountPerPeriod(this.cartItem.mileageOption.relativeAmount.amount, this.cartItem.mileageOption.config.includedAmount, this.cartItem.mileageOption.relativeAmount.calculationType, t, this.cartItem.mileageOption.config.unit)}
            {mileageTotalAmount &&
            <div class="CRItemRowMileageTotalAmount">
              {mileageTotalAmount}
            </div>
            }
          </div>
          <span class="CRItemRowPrice">
            {this.cartItem.qty + ' x '}

            <rentware-item-price price={this.cartItem.mileageOption.relativePrice.price} />
            {this.showTotalPriceForMileage(this.cartItem.mileageOption.relativePrice, this.cartItem.mileageOption.price) &&
              <Fragment>
                <br/>
                <rtr-cart-item-total-price price={this.cartItem.mileageOption.price} />
              </Fragment>
            }
          </span>
        </div>
      </Fragment>
    )
  }

  get renderProducts() {
    return (
      <Fragment>
        {/* base item */}
        <div class="CRItemRow">

          <div>{t(itemKey(this.cartItem.itemId), {}, this.cartItem.name)}</div>

          <span class="CRItemRowPrice">
            {this.cartItem.qty + ' x '}

            <rentware-item-price price={this.cartItem.individualDiscountedPrice} />
            {this.showTotalPriceForCartItem(this.cartItem.individualDiscountedPrice, this.cartItem.discountedPrice) &&
              <Fragment>
                <br/>
                <rtr-cart-item-total-price price={this.cartItem.discountedPrice} />
              </Fragment>
            }
          </span>
        </div>

        {/* variations */}
        {this.variationInCart &&
          this.variationInCart.items.map(variationItem => {
            return (
              <Fragment>
                <rentware-spacer size="S" />

                <div class="CRItemRow">
                  {variationItem.name}
                  &nbsp;x&nbsp;
                  {variationItem.quantity}
                </div>
              </Fragment>
            );
          })}

        {/* mileage */}
        {this.renderMileage()}

        {/* bundles */}
        {!this.bundles?.length &&
          this.bundles?.map((bundle: CartItemProduct) => {
            return (
              <Fragment>
                <rentware-spacer size="S" />

                <div class="CRItemRow">
                  {bundle.name}
                  &nbsp;x&nbsp;
                  {bundle.quantity}
                </div>
              </Fragment>
            );
          })}

        {/* connected articles */}
        {this.connectedArticles.map((connectedArticle: ConnectedArticle) => {
          const price = connectedArticle.individualDiscountedPrice
          if (!price.priceCalculation) {
            price.priceCalculation = connectedArticle.priceCalculationType;
          }

          return (
            <Fragment>
              <rentware-spacer size="S" />

              <div class="CRItemRow">
                {t(itemKey(connectedArticle.itemId), {}, connectedArticle.name)}

                {!connectedArticle.isDeposit &&
                <span class="CRItemRowPrice">
                  {connectedArticle.connectedAmount && connectedArticle.connectedAmount + ' x '}

                  <rentware-item-price price={price} />
                </span>
                }
              </div>
            </Fragment>
          );
        })}

        {/* deposit */}
      </Fragment>
    );
  }

  render() {
    return (
      <Host class="CRContent">
        <rentware-spacer size="M" />

        <rtr-article-details-gallery images={this.images} onShowFullGallery={this.onShowFullGallery} static={true} />

        <rentware-spacer size="M" />

        {this.renderProducts}

        <rentware-spacer size="S" />
      </Host>
    );
  }
}
